import * as CONST from "../const/action.const";
import * as UTILS from "../helpers/utils"

const initialState = {
  assignments_list: [],
  new_assignment: null,
  info_assignment: null,
  replies_assignment: null,
  grade_answer_assignment: null,
  student_answer_assignment: null,
  teacher_answer_assignment: null,
  assingments_homework: null
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.FIND_ASSIGNMENTS_HOMEOWRK_SUCCESS:
      return {
        ...state,
        assingments_homework: payload,
      };
    case CONST.FIND_ASSIGNMENTS_HOMEOWRK_FAILURE:
      return {
        ...state,
        assingments_homework: null,
      };
    
    case CONST.CREATE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        new_assignment: payload,
        assignments_list: state.assignments_list.concat(payload),
      };
    case CONST.CREATE_ASSIGNMENT_FAILURE:
      return {
        ...state,
        new_assignment: null,
      };
    case CONST.GET_ASSIGNMENTS_LIST_SUCCESS:
      return {
        ...state,
        assignments_list: payload.reverse(),
      };
    case CONST.GET_ASSIGNMENTS_LIST_FAILURE:
      return {
        ...state,
        assignments_list: [],
      };
    case CONST.FIND_ASSIGNMENT_SUCCESS:
      console.log("ol",payload)
      return {
        ...state,
        info_assignment: payload,
      };
    case CONST.FIND_ASSIGNMENT_FAILURE:
      return {
        ...state,
        info_assignment: null,
      };
    case CONST.UPDATE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        info_assignment: payload,
      };
    case CONST.UPDATE_ASSIGNMENT_FAILURE:
      return {
        ...state,
        info_assignment: payload,
      };
    case CONST.DELETE_ASSIGNMENT_SUCCESS:
      let new_assignments_list = [...state.assignments_list]
      console.log("payload.id", payload)
      new_assignments_list = UTILS.removeObjectWithId(new_assignments_list, payload)
      console.log("new_assignments_list", new_assignments_list)
      return {
        ...state,
        assignments_list: [...new_assignments_list],
      };
    case CONST.DELETE_ASSIGNMENT_FAILURE:
      return {
        ...state,
        assignments_list: state.assignments_list,
      };
    case CONST.SUBMIT_REPLY_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        student_answer_assignment: payload,//
      };
    case CONST.SUBMIT_REPLY_ASSIGNMENT_FAILURE:
      return {
        ...state,
        student_answer_assignment: payload,//
      };
    case CONST.VIEW_REPLIES_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        replies_assignment: payload,//
      };
    case CONST.VIEW_REPLIES_ASSIGNMENT_FAILURE:
      return {
        ...state,
        replies_assignment: null,//
      };
    case CONST.SUBMIT_GRADE_REPLY_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        grade_answer_assignment: payload,//
      };
    case CONST.SUBMIT_GRADE_REPLY_ASSIGNMENT_FAILURE:
      return {
        ...state,
        grade_answer_assignment: null,//
      };
    case CONST.SUBMIT_ANSWER_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        teacher_answer_assignment: payload,//
      };
    case CONST.SUBMIT_ANSWER_ASSIGNMENT_FAILURE:
      return {
        ...state,
        teacher_answer_assignment: payload,//
      };
    default:
      return state;
  }
}
